var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMapmarker = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53553 9.91053C8.95015 10.4959 7.72598 11.7201 6.88362 12.5624C6.39547 13.0506 5.6048 13.0509 5.11664 12.5627C4.28896 11.735 3.08849 10.5346 2.46447 9.91053C0.511845 7.95791 0.511845 4.79209 2.46447 2.83947C4.41709 0.886845 7.58291 0.886845 9.53553 2.83947C11.4882 4.79209 11.4882 7.95791 9.53553 9.91053Z",
    stroke: "#605E5E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 6.375C7.875 7.41053 7.03553 8.25 6 8.25C4.96447 8.25 4.125 7.41053 4.125 6.375C4.125 5.33947 4.96447 4.5 6 4.5C7.03553 4.5 7.875 5.33947 7.875 6.375Z",
    stroke: "#605E5E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMapmarker, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mapmarker.df27101f.svg";
export { ForwardRef as ReactComponent };